import { createFileRoute } from '@tanstack/react-router'
import { Suspense, lazy } from 'react'
import { protectedRouteGuard } from '@/utils/routeGuards'

import { Loading } from '@/components/Loading'

const TalosImageConfigPage = lazy(
  () => import('@/features/Servers/pages/TalosImageConfigPage'),
)

export const Route = createFileRoute('/infra/servers/prepare-image')({
  beforeLoad: protectedRouteGuard,
  loader: () => ({
    crumb: 'Talos OS Image Configuration',
  }),
  component: () => (
    <Suspense fallback={<Loading />}>
      <TalosImageConfigPage />
    </Suspense>
  ),
})
